import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/api/participants';

export default {
	/*
		Get list
	*/
	getList(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Guest - Get list
	*/
	guestGetList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/guest/list?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get Me
	*/
	getMe(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `${endpoint}/me?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details
	*/
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create
	*/
	create(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create bulk
	*/
	createBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk_create`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update leave
	*/
	updateLeave(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/update_leave`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk delete
	*/
	bulkDelete(ids, cb, errorCb) {
		const params = {
			participant_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Bulk change pemission
	*/
	bulkChangePermission(params, cb, errorCb) {
		const url = `${endpoint}/bulk_change_permission`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Send email
	*/
	sendEmail(params, cb, errorCb) {
		const url = `${endpoint}/send_email`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Check-in participant
	*/
	checkedin(params, cb, errorCb) {
		const url = `${endpoint}/checkedin`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk - Force logout
	*/
	forceLogout(params, cb, errorCb) {
		const url = `${endpoint}/force_logout`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Switch Delegate ID
	*/
	switchDelegateID(params, cb, errorCb) {
		const url = `${endpoint}/switch_delegate_id`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Identity Logs
	*/
	identityLogs(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `${endpoint}/identity_number_logs?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get list
	*/
	getStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/stats?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Check-in floor
	*/
	checkFloor(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/check_floor`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Check-in or Checkout
	*/
	checkin(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/checkin`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
